
// (function ($) {
//     // Background video functionality has been moved to assets/js/main/background-videos.js
//     // This file is kept for potential video_banner-specific functionality in the future
// })(jQuery);

// document.addEventListener("DOMContentLoaded", () => {
//     const banner = document.querySelector(".video_banner");
//     if (!banner) return;

//     let ticking = false;

//     function updateScroll() {
//         const scrolled = window.scrollY;

//         // TUNE FACTOR
//         const shift = scrolled * 0.2;

//         banner.style.transform = `translateY(-${shift}px)`;

//         ticking = false;
//     }

//     window.addEventListener("scroll", () => {
//         if (!ticking) {
//             requestAnimationFrame(updateScroll);
//             ticking = true;
//         }
//     });
// });
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.modal-banner-video').forEach((modal) => {
        const iframe = modal.querySelector('iframe');

        if (!iframe) {
            return;
        }

        const originalSrc = iframe.src;

        modal.addEventListener('shown.bs.modal', function () {
            const url = new URL(originalSrc);

            url.searchParams.set('autoplay', '1');

            iframe.src = url.toString();
        });

        modal.addEventListener('hide.bs.modal', function () {
            iframe.src = originalSrc;
        });
    });
});